<router-outlet></router-outlet>
<ng-container *ngIf="route.children.length === 0">

  <div class="row">
    <div class="col-xs-12 col-md-6">
      <div class="card">
        <div class="content">

          <!-- Initial -->
          <ng-container *ngIf="state === eWorkflowState.INITIAL">
            <h4 class="text-center">Synchronise Users from People HR</h4>
            <p>
              Once synchronised, all users in People HR will be managed and kept up-to-date in Frankli by People HR.
              <a target="_blank" href="https://help.frankli.io/en/articles/5529866-people-hr-integration">Learn more</a>
            </p>
            <hr>
            <div class="text-center">
              <button class="btn-frankli-round btn-frankli-green" [disabled]="loadingSetup" (click)="startSetup()">
                Setup People HR
                <span *ngIf="loadingSetup" class="m-left-10 fas fa-spin fa-spinner fa-fw"></span>
              </button>
            </div>
          </ng-container>

          <!-- Set up -->
          <ng-container *ngIf="state === eWorkflowState.SETUP">
            <form [formGroup]="setupForm">

              <h4 class="text-center">Connect Frankli and People HR</h4>

              <!-- API -->
              <div class="row">
                <div class="col-xs-12">
                  <p>
                    In order to connect Frankli with People HR, you need to provide your People HR <code>API Key</code>
                    with the correct permissions enabled.
                    <a target="_blank"
                      href="https://help.frankli.io/en/articles/5529866-people-hr-integration#h_14aaea4d51">Learn
                      more</a>
                  </p>
                </div>

                <div class="col-xs-12 m-top-15">

                  <div class="frankli-form-group frankli-form-group-filled frankli-form-group-placeholder-shown"
                    [class.frankli-form-group-invalid]="setupSubmitted && (setupForm.controls.key.invalid || setupApiKeyInvalid)">
                    <label for="setupKey">
                      API Key
                    </label>
                    <input id="setupKey" placeholder="Paste API Key here" class="form-control" type="text"
                      [formControl]="setupForm.controls.key">
                    <div class="frankli-form-group-alert">
                      <div
                        *ngIf="setupForm.controls.key.invalid && setupSubmitted && setupForm.controls.key.hasError('required')">
                        API Key is required
                      </div>
                      <div *ngIf="setupApiKeyInvalid && setupSubmitted">
                        {{setupApiKeyInvalid}}
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <!-- Webhooks -->
              <div class="row m-top-15">
                <div class="col-xs-12">

                  <p>
                    In order for Frankli to receive live updates from People HR, you need to add the below
                    <code>Webhook URL</code> to People HR.
                    Whenever you perform an update in People HR, the changes will be synchronised in Frankli.
                    <a target="_blank"
                      href="https://help.frankli.io/en/articles/5529866-people-hr-integration#h_4620a239de">Learn
                      more</a>
                  </p>
                  <div class="frankli-form-group frankli-form-group-filled">
                    <label for="syncToken">
                      Webhook URL
                      <span class="clickable m-left-5 fal" [ngClass]="syncTokenCopied ? 'fa-check' : 'fa-copy'"
                        [copy-clipboard]="webhookURL" (copied)="syncTokenCopied = true"
                        (mouseout)="timeoutCheckmarkIcon()"
                        [tooltip]="syncTokenCopied ? 'Webhook URL Copied to Clipboard' : 'Copy Webhook URL to Clipboard'">
                      </span>
                    </label>
                    <input id="syncToken" disabled class="form-control" type="text" [value]="webhookURL">
                  </div>

                </div>
              </div>

              <div class="row m-top-30">
                <div class="col-xs-12 text-center">
                  <button class="btn-frankli-round btn-frankli-green" [disabled]="setupCompleting"
                    (click)="completeSetup()">
                    Complete Setup
                    <span *ngIf="setupCompleting" class="m-left-10 fas fa-spin fa-spinner fa-fw"></span>
                  </button>
                </div>
              </div>

            </form>
          </ng-container>

          <!-- Syncing -->
          <ng-container *ngIf="state === eWorkflowState.SYNCING">
            <div class="row">
              <div class="col-xs-12 text-center">
                <p>Syncing users with People HR, this may take some time...</p>
                <span class="fas fa-spin fa-spinner fa-2x fa-fw"></span>
              </div>
            </div>
          </ng-container>

          <!-- Complete -->
          <ng-container *ngIf="state === eWorkflowState.COMPLETE">
            <h4 class="m-top-0">People HR syncing enabled</h4>
            <div class="row">
              <div class="col-xs-12">
                <div class="frankli-form-group frankli-form-group-filled"
                  [class.frankli-form-group-invalid]="apiKey.error">
                  <label for="apiKey">
                    API Key
                    <span class="clickable m-left-5 fal" [ngClass]="apiKeyCopied ? 'fa-check' : 'fa-copy'"
                      [copy-clipboard]="apiKey.token" (copied)="apiKeyCopied = true"
                      (mouseout)="timeoutCheckmarkIconApiKey()"
                      [tooltip]="apiKeyCopied ? 'API Key Copied to Clipboard' : 'Copy API Key to Clipboard'">
                    </span>
                  </label>
                  <input id="apiKey" disabled class="form-control" type="text" [value]="apiKey.token">
                  <div *ngIf="apiKey.error" class="alert alert-danger text-center m-top-15 m-bottom-0">
                    {{apiKey.error}}
                  </div>
                  <!-- (added on: {{apiKey.created | date: 'dd/MM/yyyy'}}) -->
                </div>
              </div>
            </div>

            <div class="row m-top-15">
              <div class="col-xs-12">
                <div class="frankli-form-group frankli-form-group-filled">
                  <label for="currentWebhookURL">
                    Webhook URL
                    <span class="clickable m-left-5 fal" [ngClass]="webhookUrlCopied ? 'fa-check' : 'fa-copy'"
                      [copy-clipboard]="webhookURL" (copied)="webhookUrlCopied = true"
                      (mouseout)="timeoutCheckmarkIconWebhook()"
                      [tooltip]="webhookUrlCopied ? 'Webhook URL Copied to Clipboard' : 'Copy Webhook URL to Clipboard'">
                    </span>
                  </label>
                  <input id="currentWebhookURL" disabled class="form-control" type="text" [value]="webhookURL">
                  <div *ngIf="syncToken.lastSync === null">
                    <p>
                      Last sync on: {{apiKey.created | date: 'dd/MM/yyyy h:mm a'}}
                    </p>
                  </div>
                  <div *ngIf="syncToken.lastSync !== null">
                    <p>
                      Last sync on: {{syncToken.lastSync | date: 'dd/MM/yyyy h:mm a'}}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row m-top-15">
              <div class="col-xs-12 text-right">
                <button class="btn-frankli-round btn-frankli-green" [disabled]="loadingManualSync" (click)="performManualSync()">
                  Perform Manual Sync
                  <span *ngIf="loadingManualSync" class="m-left-10 fas fa-spin fa-spinner fa-fw"></span>
                </button>
                <span class="m-right-5"></span>
                <button class="btn-frankli-round btn-frankli-green" (click)="startUpdate()">
                  Update API Key
                </button>
                <span class="m-right-5"></span>
                <button class="btn-frankli-round btn-frankli-red" [disabled]="loadingDisableSync"
                  (click)="disableSync()">
                  Disable Syncing
                  <span *ngIf="loadingDisableSync" class="m-left-10 fas fa-spin fa-spinner fa-fw"></span>
                </button>
              </div>
            </div>

          </ng-container>

          <!-- Update API Key -->
          <ng-container *ngIf="state === eWorkflowState.UPDATE">
            <form [formGroup]="setupForm">

              <h4 class="text-center">Update API Key</h4>

              <div class="row">
                <div class="col-xs-12">
                  <p>
                    In order to connect Frankli with People HR, you need to provide your People HR <code>API Key</code>
                    with the correct permissions enabled.
                    <a target="_blank"
                      href="https://help.frankli.io/en/articles/5529866-people-hr-integration#h_14aaea4d51">Learn
                      more</a>
                  </p>
                </div>

                <div class="col-xs-12 m-top-15">

                  <div class="frankli-form-group frankli-form-group-filled frankli-form-group-placeholder-shown"
                    [class.frankli-form-group-invalid]="setupSubmitted && (setupForm.controls.key.invalid || setupApiKeyInvalid)">
                    <label for="setupKey">
                      API Key
                    </label>
                    <input id="setupKey" placeholder="Paste API Key here" class="form-control" type="text"
                      [formControl]="setupForm.controls.key">
                    <div class="frankli-form-group-alert">
                      <div
                        *ngIf="setupForm.controls.key.invalid && setupSubmitted && setupForm.controls.key.hasError('required')">
                        API Key is required
                      </div>
                      <div *ngIf="setupApiKeyInvalid && setupSubmitted">
                        {{setupApiKeyInvalid}}
                      </div>
                    </div>
                  </div>

                </div>

                <div class="col-xs-12 text-center m-top-15">
                  <button type="button" class="btn-frankli-round btn-frankli-cancel" (click)="cancelUpdate()">Cancel</button>
                  <button class="btn-frankli-round btn-frankli-green" [disabled]="setupCompleting"
                    (click)="completeSetup()">
                    Update API Key
                    <span *ngIf="setupCompleting" class="m-left-10 fas fa-spin fa-spinner fa-fw"></span>
                  </button>
                </div>
              </div>

            </form>
          </ng-container>

        </div>
      </div>
    </div>
  </div>


</ng-container>